export async function PacienteAdminUpdate(
  firstName,
  lastName,
  sexoPacie,
  direccion,
  direccionNum,
  direccionPiso,
  direccionCiudad,
  direccionProvincia,
  direccionCp,
  email,
  telefono,
  dni,
  nacimiento,
  username,
  hce,
  nombreFamiliar,
  telefonoFamiliar,
  estadoUsuario,
  credito,
  pacienteId
) {
  console.log(
    firstName,
    lastName,
    direccion,
    direccionNum,
    sexoPacie,
    direccionPiso,
    direccionCiudad,
    direccionProvincia,
    direccionCp,
    email,
    telefono,
    dni,
    nacimiento,
    username,
    hce,
    nombreFamiliar,
    telefonoFamiliar,
    estadoUsuario,
    credito,
    pacienteId
  );
  const formData = {
    username: username,
    email: email,
    first_name: firstName,
    last_name: lastName,
    name: firstName + " " + lastName,
    // roles: ['contributor'],
    roles: ["subscriber"],
    meta: {
      dni: dni,
      nacimiento: nacimiento,
      telefono: telefono,
      hce: hce,
      sexo_paciente: sexoPacie,
      direccion: direccion,
      direccion_num: direccionNum,
      direccion_piso: direccionPiso,
      direccion_ciudad: direccionCiudad,
      direccion_provincia: direccionProvincia,
      direccion_cp: direccionCp,
      nombre_familiar: nombreFamiliar,
      telefono_familiar: telefonoFamiliar,
      estado: estadoUsuario,
      credito: credito,
    },
  };

  const authToken = sessionStorage.getItem("token");

  try {
    const response = await fetch(
      `https://app.tavad.com/hce/wp-json/wp/v2/users/${pacienteId}`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(formData),
      }
    );
    const values = await response.json();
    console.log(values);
    return values;
  } catch (error) {
    console.error(error);
  }
}
